import { render, staticRenderFns } from "./WithdrawConfig.vue?vue&type=template&id=5ed6164e&scoped=true"
import script from "./WithdrawConfig.vue?vue&type=script&lang=js"
export * from "./WithdrawConfig.vue?vue&type=script&lang=js"
import style0 from "./WithdrawConfig.vue?vue&type=style&index=0&id=5ed6164e&prod&scoped=true&lang=css"
import style1 from "./WithdrawConfig.vue?vue&type=style&index=1&id=5ed6164e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6164e",
  null
  
)

export default component.exports